import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  overflow: hidden;
`;
Wrapper.displayName = 'Wrapper';
